import type { WebViewIntent } from '@/lib/react-native/services/react-native.intent'
import { createIntent } from '@/lib/react-native/services/react-native.intent'

export function createRedirectIntent({ to }: { to: string }): WebViewIntent {
  return createIntent('REDIRECT', { to })
}
